import { MANAGE_TABLE } from "app/ManageTables/types";
import { AnyAction } from "redux";
import { IGPTable } from "ui/Table/Table";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { FETCH_SUCCESS, TABLE_UPDATE } from "../types";

function LocationSuppliersTable(
    state: IGPTable = {
        id: "LocationSuppliersTable",
        columns: [],
        availableColumns: [],
        filters: {},
        filterSettings: {
            open: false,
            total: 0,
        },
        pagination: {
            page: 1,
            per_page: 20,
            isLastPage: true,
            total: 0,
        },
        search: "",
        selection: {
            id: "id",
            selected: [],
        },
        selectionActions: null,
        sort: { "supplier.name": "asc" },
        with: [],
    },
    action: AnyAction
) {
    switch (action.type) {
        case FETCH_SUCCESS:
            if (action.response.config.params?._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;
        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;
        case TABLE_UPDATE:
            return tableUpdate(state, action);
        default:
            return state;
    }
}

export default LocationSuppliersTable;
